export const initialState = () => ({
  survey: {
    name: "",
    category: ""
  },
  questions: []
})
